module.exports = {
  "id": "retry",
  "color": "blue",
  "title": "respawn",
  "icon": "loop",
  "description": "",
  "category": "rules",
  "searchTags": ["die","respawn","spawn","hazard","come back"],
  "exposedVariables": [
    {
      "tooltip": "set the location where this piece will respawn. The location must be a piece",
      "variableName": "respawn location",
      "spriteName": "$glitch_target",
      "input": {
        "type": "sprite",
        "id": "piece-to-respawn-from-sprite-selector"
      },
      "value": "none"
    }
  ],
  "info": [
    {
      "text": "Disappear and reappear at the respawn point after touching a hazard <i class='icon icon-tombstone red'></i>  piece.",
      "image": "provision/glitches/retry/retry.gif"
    }
  ],
  "unused_vars": [
    {
      "variableName": "health",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": "0",
        "max": "10",
        "step": "1"
      }
    },
    {
      "variableName": "damage",
      "spriteName": "$other_sprites",
      "input": {
        "type": "slider",
        "min": "0",
        "max": "10",
        "step": "1"
      }
    }
  ],
  "codeImage": "provision/glitches/retry/retry.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "image": "provision/parts/retry/retry.svg"
};